import { smartAxios } from "../axios/Axios";
import { profileEndpoints } from "./profileEndpoints";
import {
  IAdvancesImages,
  IAdvancesUpdateBrands,
  IDeleteAccount,
  IUpSellingData,
} from "./profileModels";
import { getToken } from "../../utils/localStorage";

export const getWorkDays = () => {
  return smartAxios.get(profileEndpoints.getWorkDays);
};
export const getIndustry = () => {
  return smartAxios.get(profileEndpoints.getIndustry);
};
export const getProfessionCategories = () => {
  return smartAxios.get(profileEndpoints.getProfessionCategories);
};
export const getLocation = () => {
  return smartAxios.get(profileEndpoints.getLocation);
};
export const getMyServices = () => {
  return smartAxios.get(profileEndpoints.getMyServices);
};
export const puttWokDayUpdate = (workingDays: any) => {
  return smartAxios.put(profileEndpoints.puttWokDayUpdate, workingDays);
};
export const postUpSellingCreate = (data: IUpSellingData) => {
  return smartAxios.post(profileEndpoints.postUpSellingCreate, {
    ...data,
  });
};
export const deleteMyServices = (id: any) => {
  return smartAxios.delete(`${profileEndpoints.deleteMyServices}${+id}/`);
};

export const editMyServices = (data: any) => {
  return smartAxios.put(`${profileEndpoints.editMyServices}${+data.id}/`, data);
};
export const getClients = () => {
  return smartAxios.get(profileEndpoints.getClients);
};
export const getClientLabels = () => {
  return smartAxios.get(profileEndpoints.getClientLabels);
};
export const getProfileAnalytics = () => {
  return smartAxios.get(profileEndpoints.getProfileAnalytics);
};

export const getUserView = () => {
  return smartAxios.get(profileEndpoints.getUserView);
};
export const getStories = () => {
  return smartAxios.get(profileEndpoints.getStories);
};
export const getCheckAddress = () => {
  return smartAxios.get(profileEndpoints.getCheckAddress);
};

export const getSocialProfile = () => {
  return smartAxios.get(profileEndpoints.getSocialProfile);
};
export const getClientView = (id: number) => {
  return smartAxios.get(`${profileEndpoints.getClientView}${id}/`);
};
export const getClientViewHeader = (id: number) => {
  return smartAxios.get(
    `${profileEndpoints.getClientView}${id}/header-analytics/`,
  );
};
export const getAppointmentHistoryByClient = (id: number) => {
  return smartAxios.get(
    `${profileEndpoints.getAppointmentHistoryByClient}${id}/history/`,
  );
};
export const getClientViewReviews = (id: number) => {
  return smartAxios.get(`${profileEndpoints.getClientView}${id}/reviews/`);
};
export const getUserCurrency = () => {
  return smartAxios.get(profileEndpoints.getUserCurrency);
};
export const getLogout = () => {
  const pushToken = getToken("pushToken");
  console.log("✅ pushToken =>", pushToken);
  return smartAxios.get(profileEndpoints.getLogout, {
    params: {
      pushToken: pushToken || "",
    },
  });
};
export const getClientExcelFile = () => {
  return smartAxios.get(profileEndpoints.getClientExcelFile);
};
export const getServiceExcelFile = () => {
  return smartAxios.get(profileEndpoints.getServiceExcelFile);
};
export const getUserInfoWebsite = () => {
  return smartAxios.get(profileEndpoints.getUserInfoWebsite);
};
export const postUserInfoWebsite = (url: string) => {
  return smartAxios.post(profileEndpoints.postUserInfoWebsite, {
    website: url,
  });
};

export const deleteInstagramDisconnect = () => {
  return smartAxios.delete(profileEndpoints.deleteInstagramDisconnect);
};
export const deleteWhatsappDisconnect = () => {
  return smartAxios.delete(profileEndpoints.deleteWhatsappDisconnect);
};

export const deleteWorker = (id: number) => {
  return smartAxios.delete(`${profileEndpoints.deleteWorker}${id}/`);
};
export const deleteAccountDelete = (data: IDeleteAccount) => {
  return smartAxios.delete(profileEndpoints.deleteAccountDelete, {
    data,
  });
};
export const putClientView = (data: any, id: number) => {
  return smartAxios.put(`${profileEndpoints.putClientView}${id}/`, data);
};

export const putUserInfo = (formData: FormData) => {
  return smartAxios.put(profileEndpoints.putUserInfo, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const postClientCreate = (data: any) => {
  return smartAxios.post(profileEndpoints.postClientCreate, data);
};
export const postEmailChangeRequest = (param: { email: string }) => {
  return smartAxios.post(profileEndpoints.emailChangeRequest, {
    ...param,
  });
};

export const postEmailChangeVerify = (param: {
  email: string;
  code: string;
}) => {
  return smartAxios.post(profileEndpoints.emailChangeVerify, {
    ...param,
  });
};

export const getServiceAdvancedSettings = (id: number) => {
  return smartAxios.get(`${profileEndpoints.getServiceAdvancedSettings}${id}/`);
};
export const getRateApp = () => {
  return smartAxios.get(profileEndpoints.getRateApp);
};

let firstRequestHandled = false;
export const postRateApp = async (data: any) => {
  if (firstRequestHandled) {
    return;
  }
  firstRequestHandled = true;
  try {
    const response = await smartAxios.post(
      profileEndpoints.postRateApp,
      data || {},
    );
    return response;
  } catch (error) {
    console.error("❌ Սխալ հարցման ժամանակ:", error);
    throw error;
  }
};

export const postServiceAdvancedUploadImages = (data: IAdvancesImages) => {
  return smartAxios.post(
    `${profileEndpoints.postServiceAdvancedUploadImages}${data.id}/`,
    data.images,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const putServiceAdvancedUpdateBrands = (data: IAdvancesUpdateBrands) => {
  const formData = new FormData();
  formData.append("title", data.data.title);
  formData.append("description", data.data.description);
  formData.append("old_images", data.data.old_images);

  console.log("data.data.images => ", data.data.images);

  data.data.images.forEach((item: any, index: number) => {
    formData.append("new_images", {
      uri: item.image,
      name: `photo_${index}.jpg`,
      type: "image/jpeg", // or the correct MIME type
    } as any);
  });

  return smartAxios.put(
    `${profileEndpoints.potServiceAdvancedUpdateBrands}${data.id}/`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const potServiceAdvancedUpdateImages = (
  id: number,
  old_images: number[], // Массив ID существующих изображений
  new_images: any,
) => {
  const formData = new FormData();
  const url = `${profileEndpoints.potServiceAdvancedUpdateImages}${id}/`;
  formData.append("old_images", JSON.stringify(old_images));

  new_images.forEach((item: any, index: number) => {
    formData.append("new_images", {
      uri: item.image,
      name: `photo_${index}.jpg`,
      type: "image/jpeg",
    } as any);
  });

  return smartAxios.put(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const postServiceBrandAdd = (data: IAdvancesUpdateBrands) => {
  const formData = new FormData();
  formData.append("title", data.data.title);
  formData.append("description", data.data.description);

  data.data.images.forEach((item: any, index: number) => {
    formData.append("images", {
      uri: item.image,
      name: `photo_${index}.jpg`,
      type: "image/jpeg", // or the correct MIME type
    } as any);
  });

  return smartAxios.post(
    `${profileEndpoints.postServiceBrandAdd}${data.id}/`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const getServiceBrandGet = (id: number | undefined) => {
  return smartAxios.get(`${profileEndpoints.getServiceBrandGet}${id}/`);
};

export const deleteServiceBrandDelete = (id: number | undefined) => {
  return smartAxios.delete(
    `${profileEndpoints.deleteServiceBrandDelete}${id}/`,
  );
};

export const postMyServicesToggleOnOff = (id: number) => {
  return smartAxios.post(profileEndpoints.postMyServicesToggleOnOff, {
    service_id: id,
  });
};
export const postMyServicesUpdateCount = (id: number, count: number) => {
  return smartAxios.post(profileEndpoints.postMyServicesUpdateCount, {
    service_id: id,
    service_count: count,
  });
};
export const postUploadClientsExcel = (data: any) => {
  return smartAxios.post(profileEndpoints.postUploadClientsExcel, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const postUploadServicesExcel = (data: any) => {
  return smartAxios.post(profileEndpoints.postUploadServicesExcel, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
